import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { NgReallyActionComponent } from './ng-really-click.component';
@Injectable({
    providedIn: 'root'
})
export class NgReallyClickService {
    constructor(private dialog: MatDialog) {}

    openNgReallyDialog(header: string, message: string,isIssueChangeAction?: any,ngReallyOk?: any) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            header: header,
            message: message,
            isIssueChangeAction:isIssueChangeAction,
            ngReallyOk:ngReallyOk,
        };
        const modalRef = this.dialog.open(NgReallyActionComponent, dialogConfig);

        return modalRef;
    }
}
